<template>
  <el-dialog title="审批通过" :visible.sync="DialogVisible" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
    <span>请确认是否提交申请</span>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="loading" type="default" @click="handleCancel">取消</el-button>
      <el-button :loading="loading" type="primary" @click="HandleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>
<script type="es6">
export default {
  data () {
    return {
      DialogVisible: false,
      loading: false
    };
  },
  methods: {
    openDialog () {
      this.DialogVisible = true;
      this.loading = false;
    },
    handleCancel () {
      if (this.loading) {
        return;
      }
      this.DialogVisible = false;
    },
    HandleSubmit () {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$emit('SubmitApprove', { done: this.handleDone });
    },
    handleDone (success = false) {
      this.loading = false;
      if (success) {
        this.DialogVisible = false;
      }
    }
  }
};
</script>
